import { render } from "./DynamicDialog.vue?vue&type=template&id=412d503f&ts=true"
import script from "./DynamicDialog.vue?vue&type=script&lang=ts"
export * from "./DynamicDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "412d503f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('412d503f', __exports__)) {
    api.reload('412d503f', __exports__)
  }
  
  module.hot.accept("./DynamicDialog.vue?vue&type=template&id=412d503f&ts=true", () => {
    api.rerender('412d503f', render)
  })

}


export default __exports__